import { Grid, Typography } from '@mui/material'
import Logo from '../assets/images/K2GLogo2.svg';
import LogoWhite from "../assets/images/K2GLogoWhite.png";

const BannerReportTIM = ({text, image=false,bgColor="#0F5385"}) => {
    return (
    <Grid container sx={{alignItems:"stretch", backgroundColor:bgColor}}>
        <Grid size={image?10:12} display={"flex"} justifyContent={"center"} flexDirection={"column"} alignItems={image?"flex-start":"center"} sx={{padding:"24px 48px"}}>
            <Typography variant="h4" fontWeight={600} color="white" dangerouslySetInnerHTML={{ __html: text }}/>
        </Grid>
        {
            image &&
            <Grid size={2} display={"flex"} justifyContent={"center"} alignItems={"center"} sx={{padding:"16px 24px"}}>
                <img src={LogoWhite} alt="LOGO" style={{width:"120px"}}/>
            </Grid>
        }
    </Grid>
    )
}

export default BannerReportTIM